import React from 'react';
import { Menu as ChakraMenu, MenuProps as ChakraMenuProps } from '@chakra-ui/react';

export function Menu(props: ChakraMenuProps) {
  return <ChakraMenu {...props} />;
}
